/**
 * file : Inquiry.jsx
 * 설명 : 문의하기
 */

import { useRef, useState, useEffect } from "react";
import SelectBox from "../components/SelectBox"
import * as swal from "../components/SwalAlert";
import emailjs from '@emailjs/browser';

export default function Inquiry() {

  // SelectBox 데이터
  const options = [
    { value: 'Basic', name: 'Basic'},
    { value: 'Enterprise', name: 'Enterprise'}
  ];

  // 성함 혹은 회사명
  const nameVal = useRef('');
  // 이메일
  const emailVal = useRef('');
  // 전화번호
  const numberVal = useRef('');
  // 제목
  const titleVal = useRef('');
  // 내용
  const contentVal = useRef('');

    // 메뉴 선택 값
  const [menuVal, _] = useState({});
  // 성함 혹은 회사명 선택 여부
  const [naemClick, setnaemClick] = useState(false);
  // 이메일 선택 여부
  const [emailClick, setemailClick] = useState(false);
  // 전화번호 선택 여부
  const [numberClick, setnumberClick] = useState(false);
  // 제목 선택 여부
  const [titleClick, settitleClick] = useState(false);
  // 내용 선택 여부
  const [contentClick, setcontentClick] = useState(false);

  
  useEffect(() => { 
    // 문의하기 버튼 클릭 용
    const inquiryclick = document.querySelectorAll('.inquiryclick');

    // 문의하기로 직접적으로 타켓팅 스크롤 하는 버튼
    inquiryclick.forEach((inquiry) => {
      inquiry.addEventListener('click', () => {
        const target = document.getElementById('inquiry');
        
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY + 1130,
          behavior: 'smooth',
        }) 
      });
    });
  })

  // inputFild 값 체크
  const inputFildFocus = (val) => {
    if (val === 'name' && nameVal.current.value.trim() === '') { setnaemClick(true) }
    else if (val === 'name' && nameVal.current.value.trim() !== ''){setnaemClick(false)}
    if(val === 'email' && emailVal.current.value.trim() === ''){ setemailClick(true) }
    else if(val === 'email' && emailVal.current.value.trim() !== ''){ setemailClick(false) }
    if (val === 'number' && numberVal.current.value.trim() === '') { setnumberClick(true) }
    else if(val === 'number' && numberVal.current.value.trim() !== ''){ setnumberClick(false) }
    if (val === 'title' && titleVal.current.value.trim() === '') { settitleClick(true) }
    else if(val === 'title' && titleVal.current.value.trim() !== ''){ settitleClick(false) }
    if (val === 'content' && contentVal.current.value.trim() === '') { setcontentClick(true) }
    else if(val === 'content' && contentVal.current.value.trim() !== '') { setcontentClick(false) }
  }

  // inputFild 값이 모두 확인 됬다면 버튼 활성화
  const inputFildCheck = () => {
    const button = document.querySelector('#submitButton');
    if (nameVal.current.value.trim() !== '' && emailVal.current.value.trim() !== '' && numberVal.current.value.trim() !== '' && titleVal.current.value.trim() !== '' && contentVal.current.value.trim() !== '') {
      button.classList.remove('disabled')
    } else {
      button.classList.add('disabled')
    }
  }

  // 메일 전송
  const send = () => {
    const datas = {
      menu: menuVal['menu'],
      name: nameVal.current.value,
      email: emailVal.current.value,
      number: numberVal.current.value,
      title: titleVal.current.value,
      content: contentVal.current.value,
    }

    emailjs.send("service_g36g51s", "template_aecdm6j", datas, "5XgjQaR8xiy3JGZwq")
    .then(() => {
        swal.SwalAlert('success', '문의 완료', `<div>정상적으로 문의 됐습니다<br/>빠른 시일 내에 확인 후 답변드리겠습니다</div>`);
    }).catch(() => {
      swal.SwalAlert('error', '오류', `<div>관리자에게 문의 해주세요</div>`);
    })
  }
  
  return (
    <section id="inquiry">
      <div className="nopaddingbackgroundImg page-section">
        <div className="container px-4 px-lg-5">
            <div className="row gx-4 gx-lg-5 justify-content-center">
              <div className="col-lg-8 col-xl-6 text-center">
                  <h2 className="mt-0 textTitle">문의하기</h2>
                  <p className="text-muted mb-5">어떤 주제의 문의든 상관 없이 언제든 문의 주시면 성심성의 것 답변 드리겠습니다</p>
              </div>
            </div>
            <div className="row gx-4 gx-lg-5 justify-content-center mb-5">
              <div className="col-lg-6">
                <div className="form-floating mb-3">
                <SelectBox title={'선택'} options={options} dataValue={menuVal} />
                </div>
                <div className="form-floating mb-3">
                  <input className="form-control" id="name" type="text" placeholder="" ref={nameVal} onBlur={ () => {inputFildFocus('name'); inputFildCheck();}} onFocus={ inputFildCheck }/>
                  <label htmlFor="name">성함 혹은 회사명</label>
                  { naemClick && <div className="invalid-feedback">이름을 입력 해주세요</div> }
                </div>
                <div className="form-floating mb-3">
                  <input className="form-control" id="email" type="email" placeholder="" ref={emailVal} onBlur={ () => {inputFildFocus('email'); inputFildCheck();}} onFocus={ inputFildCheck }/>
                  <label htmlFor="email">이메일</label>
                  { emailClick && <div className="invalid-feedback">이메일을 입력 해주세요</div> }
                </div>
                <div className="form-floating mb-3">
                <input className="form-control" id="number" type="tel" placeholder="" ref={numberVal} onBlur={() => { inputFildFocus('number');  inputFildCheck();}} onFocus={ inputFildCheck }/>
                  <label htmlFor="number">전화번호</label>
                  { numberClick && <div className="invalid-feedback">전화번호를 입력 해주세요</div> }
                </div>
                <div className="form-floating mb-3">
                  <input className="form-control" id="title" type="tel" placeholder="" ref={titleVal} onBlur={ () => {inputFildFocus('title'); inputFildCheck();}} onFocus={ inputFildCheck }/>
                  <label htmlFor="phone">제목</label>
                  { titleClick && <div className="invalid-feedback">제목을 입력 해주세요</div> }
                </div>
                <div className="form-floating mb-3">
                  <textarea className="form-control textarea textchk" id="content" type="text" placeholder="" ref={contentVal} onBlur={ () => {inputFildFocus('content'); inputFildCheck();}} onFocus={ inputFildCheck }></textarea>
                  <label htmlFor="content">내용</label>
                  { contentClick && <div className="invalid-feedback">내용을 입력 해주세요</div> }
                </div>
                <div className="d-grid">
                  <button className="btn btn-primary btn-xl disabled" id="submitButton" onClick={send}>문의하기</button>
                </div>
              </div>
            </div>
        </div>
      </div>
    </section>
  )
}